<template>
  <div class="skip_box">
    <div id="skipMobileQr"></div>
    <p class="skip_text">请使用手机扫码访问</p>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      qr: null,
    };
  },
  mounted() {
    this.toH5Mall();
  },
  methods: {
    // 生成H5二维码
    toH5Mall() {
      //   this.$nextTick(() => {
      this.qr = new QRCode("skipMobileQr", {
        width: 150,
        height: 150, // 高度
        text: location.href, // 二维码内容
      });
      console.log(this.qr);
      //   });
    },
  },
};
</script>

<style lang="scss" scoped>
.skip_box {
  padding-top: 100px;
  text-align: center;
  &::v-deep #skipMobileQr {
    img {
      //   text-align: center;
      margin: 0 auto 20px;
    }
  }
  .skip_text {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 20px;
  }
}
</style>